/* import __COLOCATED_TEMPLATE__ from './search-input.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface SearchInputSignature {
  Element: HTMLDivElement;
  Args: {
    class: string;
    value: string;
    name: string;
    handleUpdate(e: Event): void;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    SearchInput: typeof SearchInput;
  }
}

export default class SearchInput extends Component<SearchInputSignature> {
  @action handleUpdate(e: Event): void {
    this.args.handleUpdate?.(e);
  }
}
